import * as React from "react";
import { connect } from "react-redux";
import { Dispatch, bindActionCreators } from "redux";

import { RootState } from "../../state";
import { companySelector, similarCompaniesSelector } from "../selectors";
import SimilarCompaniesSection from "./SimilarCompaniesSection";
import { loadSimilarCompaniesWorker } from "../actions";

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

class SimilarCompaniesSectionContainer extends React.Component<Props> {
  public componentDidMount() {
    const { company, loadSimilarCompaniesWorker } = this.props;
    loadSimilarCompaniesWorker(company.id);
  }

  public render() {
    const { similarCompanies } = this.props;

    return <SimilarCompaniesSection companies={similarCompanies} />;
  }
}

function mapStateToProps(state: RootState) {
  const company = companySelector(state)!;
  const similarCompanies = similarCompaniesSelector(state);
  return { company, similarCompanies };
}

function mapDispatchToProps(dispatch: Dispatch<RootState>) {
  return bindActionCreators(
    {
      loadSimilarCompaniesWorker,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SimilarCompaniesSectionContainer);



// WEBPACK FOOTER //
// ./frontend/src/companies/components/SimilarCompaniesSectionContainer.tsx